<template>
  <div class="ui-simple-tab">
    <div class="ui-simple-tab__buttons">
      <div
        v-for="btn in buttons"
        :key="btn.id"
        :class="[
          textClasses,
          {
            'ui-simple-tab__tab--active': btn.id === selectedButton,
            'txt--color-03': btn.id !== selectedButton && disabled,
            'ui-simple-tab__tab--active-red':
              btn.activeColor && btn.id === selectedButton,
          },
        ]"
        class="
          ui-simple-tab__tab
          pb-4
          pb-8--m
        "
        @click="!disabled && $emit('click', btn)"
      >
        <slot v-bind="btn">
          {{ btn.text }}
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import { sizeValidator } from '@/lib/utils'

export default {
  name: 'UiSimpleTab',
  props: {
    selectedButton: { type: [String, Number], required: true },
    disabled: { type: Boolean, default: false },
    buttons: {
      validator: v =>
        Array.isArray(v) && v.every(button => button.id !== undefined),
      required: true,
    },
    size: {
      type: String,
      validator: sizeValidator,
      default: 'm',
    },
  },
  computed: {
    textClasses () {
      const classes = {
        xs: 'txt--14px txt--height-18px',
        s: 'txt--18px txt--height-20px',
        m: 'txt--18px txt--height-20px txt--22px--m txt--height-26px--m',
        l: 'txt--22px--m txt--height-26px--m',
        l: 'txt--24px--m txt--height-28px--m',
      }

      return classes[this.size]
    },
  },
}
</script>

<style lang="scss" scoped>
$main-border-height: 3px;
$button-border-height: 3px;

.ui-simple-tab {
  &__buttons {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: toRem(10px);
  }

  &__tab {
    position: relative;
    display: flex;
    align-items: flex-end;
    height: 100%;
    font-weight: 700;
    font-size: toRem(14px);
    line-height: toRem(18px);
    padding: toRem(10px) toRem(16px);
    border-radius: toRem(30px);
    border: 1px solid color('transp-02');
    color: color('color-03');
    transition: all 0.2s;
    cursor: pointer;

    &--active {
      border-color: color('color-06');
      color: color('color-06');
    }

    &--active-red {
      border-color: color('color-07');
      color: color('color-07');
    }
  }
}
</style>
